export default "__VITE_ASSET__DkHtQ7at__"